import Vue from 'vue'
import Vuex from 'vuex'
import ContactService from '@/services/ContactService'
import {READY, LOADING_START, LOADING_END, LANG_CHANGED} from './mutation-types.js'
import moduleForm from './form'
import moduleSession from './session'
import modulePxData from './pxdata'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    [moduleForm.name]: moduleForm,
    [moduleSession.name]: moduleSession,
    [modulePxData.name]: modulePxData
  },
  getters: {
    loading: state => state.loading,
    ready: state => state.ready,
    entities: state => state.entity_types,
    lang: state => state.lang,
    mapLang: state => ['fr', 'es', 'en'].includes(state.lang) ? state.lang : 'en'
  },
  state: {
    loading: false,
    ready: false,
    entity_types: [
      'agency',
      'internationalbusiness',
      'localbusiness'
    ],
    lang: 'en'
  },
  mutations: {
    [READY] (state) {
      state.ready = true
    },
    [LOADING_START] (state) {
      state.loading = true
    },
    [LOADING_END] (state) {
      state.loading = false
    },
    [LANG_CHANGED] (state, lang) {
      state.lang = lang
    }
  },
  actions: {
    ready ({commit}) {
      commit(READY)
    },
    loading ({commit}, loading) {
      if (loading) {
        commit(LOADING_START)
      } else {
        commit(LOADING_END)
      }
    },
    langChanged ({commit}, lang) {
      commit(LANG_CHANGED, lang)
    },
    dataStructure ({dispatch}, structure) {
      dispatch('form/structure', structure, {root: true})
    },
    sendInformationsAndGetAudience ({dispatch}, informations) {
      return new Promise((resolve, reject) => {
        ContactService.sendSimulation(informations).then(response => {
          dispatch('session/saveData', informations)
          dispatch('form/get_audience', response.data)
          resolve(response.data)
        }).catch(err => {
          reject(err)
        }) // send contact form & simulation data
      })
    }
  }
})
